import React from "react";
import { titleCodes, textCodes, imageCodes } from "../../template_codes/synergy/about_page_codes";

function About() {

    return (
        <div className="bg-white">
            <div className="mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 2xl:grid-cols-2 items-center pt-8 gap-x-8 px-4 lg:max-w-7xl xl:max-w-7xl 2xl:max-w-7xl lg:grid-cols-2 xl:grid-cols-2 2xl:grid-cols-2 lg:px-8  xl:px-8 2xl:px-8">
                <div className="pb-20">
                    <p className="text-md">{textCodes.estab.text}</p>
                    <h1 className="font-bold text-4xl pb-4 text-gray-700">{titleCodes.synergyGarment.title}</h1>

                    <dl className="mt-4 grid grid-cols-1 gap-x-6 gap-y-4 lg:gap-x-8">
                        <h2 className="font-bold text-xl text-gray-700">{titleCodes.missionTitle.title}</h2>
                        <p className="text-gray-500">{textCodes.missionText.text}</p>
                        <hr></hr>

                        <h2 className="font-bold text-xl text-gray-700">{titleCodes.visionTitle.title}</h2>
                        <p className="text-gray-500">{textCodes.visionText.text}</p>
                        <hr></hr>

                        <h2 className="font-bold text-xl text-gray-700">{titleCodes.valuesTitle.title}</h2>
                        <p className="text-gray-500">{textCodes.valuesText.text}</p>
                        <hr></hr>
                    </dl>
                </div>
                <div className="mb-8">
                    <img src={imageCodes.aboutImg.image} alt="Our Values" className="rounded-lg" />
                </div>
            </div>
        </div>
    );
}

export default About;